import React, { useEffect, useState } from "react";

const AnimatedNumber = ({ start, end, duration, children, ...props }) => {
  const [count, setCount] = useState(start);

  if(end === null || isNaN(end)) {
    start = -1;
    end = 0;
  }

  useEffect(() => {
    if (start === end) {
      setCount(end);
      return;
    }

    let current = start;
    const range = end - start;
    const increment = end > start ? 1 : -1;

    const step = Math.max(1, Math.floor(duration / Math.abs(range)));

    const timer = setInterval(() => {
      current += increment;
      setCount(current);
      if (current === end) {
        clearInterval(timer);
      }
    }, step);

    return () => clearInterval(timer);
  }, [start, end, duration]);

  return (
    <span {...props}>
      {count}
      {children}
    </span>
  );
};

export default AnimatedNumber;
